module.exports = __webpack_public_path__ + "static/media/newFeatures2.fda3250e.jpeg";